import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';

function ReceiptSkeleton() {
    return (
        <Column fullWidth spacing={2}>
            <Column fullWidth spacing={1.5}>
                <Skeleton width={100}
                    height={16} />
                <Skeleton width='80%' height={16} />
                <Skeleton width='60%' height={16} />
            </Column>
            <Skeleton width='100%' height={20} />
            <Row fullWidth justify='space-between'>
                <Skeleton width={100} />
                <Skeleton width={100} />
            </Row>
            <Skeleton width='100%' height={20} />
            <Row fullWidth justify='space-between'>
                <Skeleton width={100} />
                <Skeleton width={100} />
            </Row>
            <Row fullWidth justify='space-between'>
                <Skeleton width={100} />
                <Skeleton width={100} />
            </Row>
            <Skeleton width='100%' height={20} />
            <Skeleton width={80} />
            <Skeleton width={90} />
            <Skeleton width={110} />
            <Skeleton width='100%' height={20} />
        </Column>
    );
}

export default ReceiptSkeleton;
